import { RecordDto } from "@/core/common/entities/record.dto";
import { VehicleRecordTypeEnum } from "@altertec_gparn/lib";
import { get } from "lodash";

export class VehicleRecordDto extends RecordDto {
  vehicleId: string;
  translateEntityName = "el vehículo";

  translateKeys = {
    code: "el código",
    licensePlate: "la matrícula",
    brand: "la marca",
    model: "el modelo",
    dailyCost: "el coste por día",
    companyId: "la empresa",
    operativeUnitId: "la unidad operativa",
    registrationDate: "la fecha de alta",
    deregistrationDate: "la fecha de baja",
    vehicleType: "el tipo de vehículo",
    usageType: "el tipo de uso",
    acquisitionType: "el tipo de adquisición",
    vehicleFuelType: "el tipo de combustible",
    seatsCount: "el número de plazas",
    photoUrl: "la foto",
    latestMileage: "el kilometraje",
    nextChecklistDeadline: "la fecha de próxima checklist",
    responsibleId: "el responsable",
    archived: "archivado",
  };

  getTargetField(): string {
    if (!this.targetField) return;
    return get(this.translateKeys, this.targetField, this.targetField);
  }

  getSubtype(): string {
    if (this.subtype === VehicleRecordTypeEnum.OPERATIVE_UNIT_CHANGE) {
      return "Cambió la unidad operativa del vehículo";
    }

    return this.subtype;
  }
}
